import React from "react";

const SearchInformation = ({ labelText, spanText, img, imgClass }) => {
  return (
    <div className="xl:pl-4 pl-3 pr-2 py-2 bg-white rounded-lg flex items-center w-auto border border-gray-tenken-300">
      <div className="flex flex-col">
        <label className=" text-tenken-gray-700 whitespace-nowrap">
          {labelText}
        </label>
        <span className="font-bold mt-1 whitespace-nowrap">
          {spanText}
        </span>
      </div>
      <div className={`ml-5 ${imgClass}`}>
        <img src={img} alt={labelText} className={imgClass} />
      </div>
    </div>
  );
};

export default SearchInformation;
